import React from 'react';
import { BasicRoundSpinner } from '../shared/assets/BasicRoundSpinner';

// Drawer body loading state (WS-11.2): journey content loads lazily, so while its chunk
// resolves the Shell shows this in the body — an open drawer reads as "loading" rather
// than blank. This is Shell chrome (the frame's own loading affordance), not journey
// content, so it lives in the Shell and is supplied to JourneyContent's lazy wrapper.
export const DrawerLoading = () => (
  <div
    className="sui-flex sui-h-full sui-w-full sui-items-center sui-justify-center sui-py-8"
    role="status"
    aria-live="polite"
    aria-label="Loading the assistant"
  >
    <BasicRoundSpinner />
  </div>
);
